import { css } from '@emotion/react';
import { HEADER_HEIGHT, useMiniChatShallowStore } from '@frontend/mini-chat-store';
import { breakpoints, useMatchMedia } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';
import { DraftSizeProgressBar, DraftSizeProgressLoading } from './draft-size-progress';

type Props = {
  totalSize: 'loading' | number;
};

export const FaxCreationFooter = ({ totalSize }: Props) => {
  return <BaseFooter totalSize={totalSize} />;
};

type BaseFooterProps = {
  totalSize: 'loading' | number;
};
const BaseFooter = ({ totalSize }: BaseFooterProps) => {
  const { chats, rolledUp } = useMiniChatShallowStore('chats', 'rolledUp');
  const isMobileMiniChats = useMatchMedia({ maxWidth: breakpoints.xsmall.max });
  const showBottomPadding = !!chats.length && !rolledUp && !isMobileMiniChats;

  return (
    <footer
      css={css`
        background: ${theme.colors.white};
        padding: ${theme.spacing(3)};
        border-top: 1px solid ${theme.colors.neutral20};
        padding-bottom: ${showBottomPadding
          ? `${Number(theme.spacing(3).replace('px', '')) + HEADER_HEIGHT}px`
          : theme.spacing(3)};
        transition: padding-bottom 300ms ease-in-out;
      `}
    >
      {totalSize === 'loading' ? (
        <DraftSizeProgressLoading
          css={css`
            width: 100%;
            text-align: center;
          `}
        />
      ) : (
        <DraftSizeProgressBar
          css={css`
            width: 100%;
            text-align: center;
          `}
          value={totalSize}
          max={50}
        />
      )}
    </footer>
  );
};
